import { c } from 'ttag';

interface LeadingNumbers {
    countryCode: string;
    areaCodes: string[];
}

export const callingCodeToLeading: { [key: string]: LeadingNumbers[] | undefined } = {
    '1': [
        {
            countryCode: 'AG',
            areaCodes: ['268'],
        },
        {
            countryCode: 'AI',
            areaCodes: ['264'],
        },
        {
            countryCode: 'AS',
            areaCodes: ['684'],
        },
        {
            countryCode: 'BB',
            areaCodes: ['246'],
        },
        {
            countryCode: 'BM',
            areaCodes: ['441'],
        },
        {
            countryCode: 'BS',
            areaCodes: ['242'],
        },
        {
            countryCode: 'CA',
            areaCodes: [
                '204',
                '226',
                '236',
                '249',
                '250',
                '263',
                '289',
                '306',
                '343',
                '354',
                '365',
                '367',
                '368',
                '382',
                '387',
                '403',
                '416',
                '418',
                '428',
                '431',
                '437',
                '438',
                '450',
                '584',
                '468',
                '474',
                '506',
                '514',
                '519',
                '548',
                '579',
                '581',
                '584',
                '587',
                '604',
                '613',
                '639',
                '647',
                '672',
                '683',
                '705',
                '709',
                '742',
                '753',
                '778',
                '780',
                '782',
                '807',
                '819',
                '825',
                '867',
                '873',
                '902',
                '905',
            ],
        },
        {
            countryCode: 'DM',
            areaCodes: ['767'],
        },
        {
            countryCode: 'DO',
            areaCodes: ['809', '829', '849'],
        },
        {
            countryCode: 'GD',
            areaCodes: ['473'],
        },
        {
            countryCode: 'GU',
            areaCodes: ['671'],
        },
        {
            countryCode: 'JM',
            areaCodes: ['876', '658'],
        },
        {
            countryCode: 'KN',
            areaCodes: ['869'],
        },
        {
            countryCode: 'KY',
            areaCodes: ['345'],
        },
        {
            countryCode: 'LC',
            areaCodes: ['758'],
        },
        {
            countryCode: 'MP',
            areaCodes: ['670'],
        },
        {
            countryCode: 'MS',
            areaCodes: ['664'],
        },
        {
            countryCode: 'PR',
            areaCodes: ['787', '939'],
        },
        {
            countryCode: 'SX',
            areaCodes: ['721'],
        },
        {
            countryCode: 'TC',
            areaCodes: ['649'],
        },
        {
            countryCode: 'TT',
            areaCodes: ['868'],
        },
        {
            countryCode: 'VC',
            areaCodes: ['784'],
        },
        {
            countryCode: 'VG',
            areaCodes: ['284'],
        },
        {
            countryCode: 'VI',
            areaCodes: ['340'],
        },
    ],
    '7': [
        {
            countryCode: 'KZ',
            areaCodes: ['33', '7'],
        },
    ],
    '39': [
        {
            countryCode: 'VA',
            areaCodes: ['06698'],
        },
    ],
    '44': [
        {
            countryCode: 'GG',
            areaCodes: ['1481', '7781', '7839', '7911'],
        },
        {
            countryCode: 'IM',
            areaCodes: ['1624', '74576', '7524', '7924', '7624'],
        },
        {
            countryCode: 'JE',
            areaCodes: ['1534', '7509', '7700', '7797', '7829', '7937'],
        },
    ],
    '47': [
        {
            countryCode: 'SJ',
            areaCodes: ['79'],
        },
    ],
    '61': [
        {
            countryCode: 'CC',
            areaCodes: ['89162'],
        },
        {
            countryCode: 'CX',
            areaCodes: ['89164'],
        },
    ],
    '212': [
        {
            countryCode: 'EH',
            areaCodes: ['5288', '5289'],
        },
    ],
    '262': [
        {
            countryCode: 'YT',
            areaCodes: ['269', '639'],
        },
    ],
    '358': [
        {
            countryCode: 'AX',
            areaCodes: ['18'],
        },
    ],
    '599': [
        {
            countryCode: 'BQ',
            areaCodes: ['3', '4', '7'],
        },
    ],
};

export const getCountryMap = (): { [key: string]: string | undefined } => ({
    AB: c('Country name').t`Abkhazia`,
    AC: c('Country name').t`Ascension Island`,
    AD: c('Country name').t`Andorra`,
    AE: c('Country name').t`United Arab Emirates`,
    AF: c('Country name').t`Afghanistan`,
    AG: c('Country name').t`Antigua and Barbuda`,
    AI: c('Country name').t`Anguilla`,
    AL: c('Country name').t`Albania`,
    AM: c('Country name').t`Armenia`,
    AO: c('Country name').t`Angola`,
    AQ: c('Country name').t`Antarctica`,
    AR: c('Country name').t`Argentina`,
    AS: c('Country name').t`American Samoa`,
    AT: c('Country name').t`Austria`,
    AU: c('Country name').t`Australia`,
    AW: c('Country name').t`Aruba`,
    AX: c('Country name').t`Åland Islands`,
    AZ: c('Country name').t`Azerbaijan`,
    BA: c('Country name').t`Bosnia and Herzegovina`,
    BB: c('Country name').t`Barbados`,
    BD: c('Country name').t`Bangladesh`,
    BE: c('Country name').t`Belgium`,
    BF: c('Country name').t`Burkina Faso`,
    BG: c('Country name').t`Bulgaria`,
    BH: c('Country name').t`Bahrain`,
    BI: c('Country name').t`Burundi`,
    BJ: c('Country name').t`Benin`,
    BL: c('Country name').t`Saint Barthélemy`,
    BM: c('Country name').t`Bermuda`,
    BN: c('Country name').t`Brunei Darussalam`,
    BO: c('Country name').t`Bolivia`,
    BQ: c('Country name').t`Bonaire, Sint Eustatius and Saba`,
    BR: c('Country name').t`Brazil`,
    BS: c('Country name').t`Bahamas`,
    BT: c('Country name').t`Bhutan`,
    BV: c('Country name').t`Bouvet Island`,
    BW: c('Country name').t`Botswana`,
    BY: c('Country name').t`Belarus`,
    BZ: c('Country name').t`Belize`,
    CA: c('Country name').t`Canada`,
    CC: c('Country name').t`Cocos (Keeling) Islands`,
    CD: c('Country name').t`Congo, Democratic Republic of the`,
    CF: c('Country name').t`Central African Republic`,
    CG: c('Country name').t`Congo`,
    CH: c('Country name').t`Switzerland`,
    CI: c('Country name').t`Côte d'Ivoire`,
    CK: c('Country name').t`Cook Islands`,
    CL: c('Country name').t`Chile`,
    CM: c('Country name').t`Cameroon`,
    CN: c('Country name').t`China`,
    CO: c('Country name').t`Colombia`,
    CR: c('Country name').t`Costa Rica`,
    CU: c('Country name').t`Cuba`,
    CV: c('Country name').t`Cape Verde`,
    CW: c('Country name').t`Curaçao`,
    CX: c('Country name').t`Christmas Island`,
    CY: c('Country name').t`Cyprus`,
    CZ: c('Country name').t`Czech Republic`,
    DE: c('Country name').t`Germany`,
    DJ: c('Country name').t`Djibouti`,
    DK: c('Country name').t`Denmark`,
    DM: c('Country name').t`Dominica`,
    DO: c('Country name').t`Dominican Republic`,
    DZ: c('Country name').t`Algeria`,
    EC: c('Country name').t`Ecuador`,
    EE: c('Country name').t`Estonia`,
    EG: c('Country name').t`Egypt`,
    EH: c('Country name').t`Western Sahara`,
    ER: c('Country name').t`Eritrea`,
    ES: c('Country name').t`Spain`,
    ET: c('Country name').t`Ethiopia`,
    FI: c('Country name').t`Finland`,
    FJ: c('Country name').t`Fiji`,
    FK: c('Country name').t`Falkland Islands`,
    FM: c('Country name').t`Federated States of Micronesia`,
    FO: c('Country name').t`Faroe Islands`,
    FR: c('Country name').t`France`,
    GA: c('Country name').t`Gabon`,
    GB: c('Country name').t`United Kingdom`,
    GD: c('Country name').t`Grenada`,
    GE: c('Country name').t`Georgia`,
    GF: c('Country name').t`French Guiana`,
    GG: c('Country name').t`Guernsey`,
    GH: c('Country name').t`Ghana`,
    GI: c('Country name').t`Gibraltar`,
    GL: c('Country name').t`Greenland`,
    GM: c('Country name').t`Gambia`,
    GN: c('Country name').t`Guinea`,
    GP: c('Country name').t`Guadeloupe`,
    GQ: c('Country name').t`Equatorial Guinea`,
    GR: c('Country name').t`Greece`,
    GS: c('Country name').t`South Georgia and the South Sandwich Islands`,
    GT: c('Country name').t`Guatemala`,
    GU: c('Country name').t`Guam`,
    GW: c('Country name').t`Guinea-Bissau`,
    GY: c('Country name').t`Guyana`,
    HK: c('Country name').t`Hong Kong`,
    HM: c('Country name').t`Heard Island and McDonald Islands`,
    HN: c('Country name').t`Honduras`,
    HR: c('Country name').t`Croatia`,
    HT: c('Country name').t`Haiti`,
    HU: c('Country name').t`Hungary`,
    ID: c('Country name').t`Indonesia`,
    IE: c('Country name').t`Ireland`,
    IL: c('Country name').t`Israel`,
    IM: c('Country name').t`Isle of Man`,
    IN: c('Country name').t`India`,
    IO: c('Country name').t`British Indian Ocean Territory`,
    IQ: c('Country name').t`Iraq`,
    IR: c('Country name').t`Iran`,
    IS: c('Country name').t`Iceland`,
    IT: c('Country name').t`Italy`,
    JE: c('Country name').t`Jersey`,
    JM: c('Country name').t`Jamaica`,
    JO: c('Country name').t`Jordan`,
    JP: c('Country name').t`Japan`,
    KE: c('Country name').t`Kenya`,
    KG: c('Country name').t`Kyrgyzstan`,
    KH: c('Country name').t`Cambodia`,
    KI: c('Country name').t`Kiribati`,
    KM: c('Country name').t`Comoros`,
    KN: c('Country name').t`Saint Kitts and Nevis`,
    KP: c('Country name').t`North Korea`,
    KR: c('Country name').t`South Korea`,
    KW: c('Country name').t`Kuwait`,
    KY: c('Country name').t`Cayman Islands`,
    KZ: c('Country name').t`Kazakhstan`,
    LA: c('Country name').t`Laos`,
    LB: c('Country name').t`Lebanon`,
    LC: c('Country name').t`Saint Lucia`,
    LI: c('Country name').t`Liechtenstein`,
    LK: c('Country name').t`Sri Lanka`,
    LR: c('Country name').t`Liberia`,
    LS: c('Country name').t`Lesotho`,
    LT: c('Country name').t`Lithuania`,
    LU: c('Country name').t`Luxembourg`,
    LV: c('Country name').t`Latvia`,
    LY: c('Country name').t`Libya`,
    MA: c('Country name').t`Morocco`,
    MC: c('Country name').t`Monaco`,
    MD: c('Country name').t`Moldova`,
    ME: c('Country name').t`Montenegro`,
    MF: c('Country name').t`Saint Martin (French Part)`,
    MG: c('Country name').t`Madagascar`,
    MH: c('Country name').t`Marshall Islands`,
    MK: c('Country name').t`North Macedonia`,
    ML: c('Country name').t`Mali`,
    MM: c('Country name').t`Myanmar`,
    MN: c('Country name').t`Mongolia`,
    MO: c('Country name').t`Macao`,
    MP: c('Country name').t`Northern Mariana Islands`,
    MQ: c('Country name').t`Martinique`,
    MR: c('Country name').t`Mauritania`,
    MS: c('Country name').t`Montserrat`,
    MT: c('Country name').t`Malta`,
    MU: c('Country name').t`Mauritius`,
    MV: c('Country name').t`Maldives`,
    MW: c('Country name').t`Malawi`,
    MX: c('Country name').t`Mexico`,
    MY: c('Country name').t`Malaysia`,
    MZ: c('Country name').t`Mozambique`,
    NA: c('Country name').t`Namibia`,
    NC: c('Country name').t`New Caledonia`,
    NE: c('Country name').t`Niger`,
    NF: c('Country name').t`Norfolk Island`,
    NG: c('Country name').t`Nigeria`,
    NI: c('Country name').t`Nicaragua`,
    NL: c('Country name').t`Netherlands`,
    NO: c('Country name').t`Norway`,
    NP: c('Country name').t`Nepal`,
    NR: c('Country name').t`Nauru`,
    NU: c('Country name').t`Niue`,
    NZ: c('Country name').t`New Zealand`,
    OM: c('Country name').t`Oman`,
    OS: c('Country name').t`South Ossetia`,
    PA: c('Country name').t`Panama`,
    PE: c('Country name').t`Peru`,
    PF: c('Country name').t`French Polynesia`,
    PG: c('Country name').t`Papua New Guinea`,
    PH: c('Country name').t`Philippines`,
    PK: c('Country name').t`Pakistan`,
    PL: c('Country name').t`Poland`,
    PM: c('Country name').t`Saint Pierre and Miquelon`,
    PN: c('Country name').t`Pitcairn`,
    PR: c('Country name').t`Puerto Rico`,
    PS: c('Country name').t`Palestine`,
    PT: c('Country name').t`Portugal`,
    PW: c('Country name').t`Palau`,
    PY: c('Country name').t`Paraguay`,
    QA: c('Country name').t`Qatar`,
    RE: c('Country name').t`Reunion`,
    RO: c('Country name').t`Romania`,
    RS: c('Country name').t`Serbia`,
    RU: c('Country name').t`Russia`,
    RW: c('Country name').t`Rwanda`,
    SA: c('Country name').t`Saudi Arabia`,
    SB: c('Country name').t`Solomon Islands`,
    SC: c('Country name').t`Seychelles`,
    SD: c('Country name').t`Sudan`,
    SE: c('Country name').t`Sweden`,
    SG: c('Country name').t`Singapore`,
    SH: c('Country name').t`Saint Helena`,
    SI: c('Country name').t`Slovenia`,
    SJ: c('Country name').t`Svalbard and Jan Mayen`,
    SK: c('Country name').t`Slovakia`,
    SL: c('Country name').t`Sierra Leone`,
    SM: c('Country name').t`San Marino`,
    SN: c('Country name').t`Senegal`,
    SO: c('Country name').t`Somalia`,
    SR: c('Country name').t`Suriname`,
    SS: c('Country name').t`South Sudan`,
    ST: c('Country name').t`Sao Tome and Principe`,
    SV: c('Country name').t`El Salvador`,
    SX: c('Country name').t`Sint Maarten`,
    SY: c('Country name').t`Syria`,
    SZ: c('Country name').t`Eswatini`,
    TA: c('Country name').t`Tristan da Cunha`,
    TC: c('Country name').t`Turks and Caicos Islands`,
    TD: c('Country name').t`Chad`,
    TF: c('Country name').t`French Southern Territories`,
    TG: c('Country name').t`Togo`,
    TH: c('Country name').t`Thailand`,
    TJ: c('Country name').t`Tajikistan`,
    TK: c('Country name').t`Tokelau`,
    TL: c('Country name').t`Timor-Leste`,
    TM: c('Country name').t`Turkmenistan`,
    TN: c('Country name').t`Tunisia`,
    TO: c('Country name').t`Tonga`,
    TR: c('Country name').t`Turkey`,
    TT: c('Country name').t`Trinidad and Tobago`,
    TV: c('Country name').t`Tuvalu`,
    TW: c('Country name').t`Taiwan`,
    TZ: c('Country name').t`Tanzania`,
    UA: c('Country name').t`Ukraine`,
    UG: c('Country name').t`Uganda`,
    UM: c('Country name').t`United States Minor Outlying Islands`,
    US: c('Country name').t`United States`,
    UY: c('Country name').t`Uruguay`,
    UZ: c('Country name').t`Uzbekistan`,
    VA: c('Country name').t`Holy See (Vatican City State)`,
    VC: c('Country name').t`Saint Vincent and the Grenadines`,
    VE: c('Country name').t`Venezuela`,
    VG: c('Country name').t`Virgin Islands, British`,
    VI: c('Country name').t`Virgin Islands, U.S.`,
    VN: c('Country name').t`Vietnam`,
    VU: c('Country name').t`Vanuatu`,
    WF: c('Country name').t`Wallis and Futuna`,
    WS: c('Country name').t`Samoa`,
    XK: c('Country name').t`Kosovo`,
    YE: c('Country name').t`Yemen`,
    YT: c('Country name').t`Mayotte`,
    ZA: c('Country name').t`South Africa`,
    ZM: c('Country name').t`Zambia`,
    ZW: c('Country name').t`Zimbabwe`,
    ZZ: c('Country name').t`International`,
});
